import { InventoryFormdataItem, InventoryGeometryItem } from "./types/inventories";
import PouchDB from "pouchdb";
import { useInventoryDatabases } from "./useDatabases";
import { useCurrentObjectId } from "../url";
import { usePouchAllDocs } from "./usePouchAllDocs";
import { filterNull, filterUndefined } from "../../utils/utils";
import { usePouchGet } from "./usePouchGet";
import { PouchDocument } from "./common";

export interface InventoryObject extends Omit<InventoryGeometryItem & PouchDB.Core.IdMeta & PouchDB.Core.RevisionIdMeta, "data"> {
  data: PouchDocument<InventoryFormdataItem>[];
}

export function useCurrentObject() {
  const { inventory } = useInventoryDatabases();
  const { inventoryId, objectId } = useCurrentObjectId();

  const {
    data: geomData,
    loading: geomLoading,
    error: geomError,
  } = usePouchGet(inventoryId ? [`inventory:${inventoryId}`] : [], inventory, objectId, {
    enabled: inventoryId !== undefined && objectId !== undefined,
  });
  const {
    data: formsData,
    loading: formsLoading,
    error: formsError,
  } = usePouchAllDocs(inventoryId ? [`inventory:${inventoryId}`] : [], inventory, {
    enabled: geomData !== undefined,
    keys: geomData?.type === "geometry" ? geomData.data : [],
  });

  const loading = geomLoading || formsLoading;
  const error = geomError || formsError;

  if (!geomData || geomData.type !== "geometry") {
    return { data: null, loading, error };
  }
  return {
    data: { ...geomData, data: filterNull(filterUndefined(formsData || [])) } as InventoryObject,
    loading,
    error,
  };
}
